export default "__VITE_ASSET__d107ea1a__"